import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms'
import { ValidationsService } from '../../services/common/validations.service';

@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html',
  styleUrls: ['./student-list.component.scss']
})
export class StudentListComponent implements OnInit {

  // @ViewChild('editTeamMemberModalRef', { static: true }) editTeamMemberModal: ElementRef;
  loggedInUserDetails;
  isLoading = true;

  optionForm: FormGroup;
  scheduleSessionForm: FormGroup;

  getStudentListPostData = {
    filterByCounselor: '',
    offset: '',
    search: '',
    sortBy: ''
  };
  studentList;
  counselorList;
  studentListForCsvDownload;

  // Pagination
  noOfPages;
  pageNumber;
  arr = Array; // Array type captured in a variable

  // Sort
  sortBy;

  // schedule session
  minDate = new Date();
  maxDate = new Date();


  constructor(private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) { }

  ngOnInit() {

    this.loggedInUserDetails = this.dashboardService.decodeToken();
    this.getStudentListPostData.filterByCounselor = this.loggedInUserDetails.counselor_id;

    this.optionForm = this.formBuilder.group({
      filterByCounselor: ['']
    });

    // schedule session
    this.scheduleSessionForm = this.formBuilder.group({
      session_date: [''],
      session_time: [''],
      session_medium: ['']
    });

    this.getStudentsList();

    this.optionForm.get('filterByCounselor').valueChanges.subscribe(optedValue => {
      this.getStudentListPostData.filterByCounselor = optedValue;
      this.getStudentListPostData.offset = '';

      this.getStudentsList();
    });

    // schedule session
    this.minDate.setDate(this.minDate.getDate() + 2);
    this.maxDate.setDate(this.minDate.getDate() + 12);

  }

  // schedule session
  // getters (scheduleSessionForm)
  get session_date() { return this.scheduleSessionForm.get('session_date'); }
  get session_time() { return this.scheduleSessionForm.get('session_time'); }
  get session_medium() { return this.scheduleSessionForm.get('session_medium'); }

  setFiltersAndGetList(event) {
    this.getStudentsList();
  }

  getStudentsList() {

    this.dashboardService.getStudentList(this.getStudentListPostData).subscribe(response => {
      this.isLoading = false;

      if (response.data != null) {
        this.counselorList = response.data.counselorList;
        this.studentList = response.data.studentList;
        this.noOfPages = response.data.count;

      }
      else {
        this.studentList = null;
      }
    });
  }

  // Download CSV
  downloadCsv() {
    const fileName = 'student-list';

    this.getStudentListPostData['download'] = 1;

    this.dashboardService.getStudentList(this.getStudentListPostData).subscribe(response => {
      if (response.data != null) {
        this.studentListForCsvDownload = response.data.studentList;
        this.dashboardService.exportToCsvService(fileName, this.studentListForCsvDownload);
      }
      else {
        this.studentListForCsvDownload = null;
      }
    });
  }

  paginate(event) {
    this.getStudentListPostData.offset = (event.first);
    this.getStudentsList();
  }

  // schedule session
  scheduleSessionFormSubmit() { }


  /*Assign*/
  assignCounselor(student_id, counselor_id) {
    this.dashboardService.assignStudentToCounselor({ 'student_id': student_id, 'counselor_id': counselor_id }).subscribe(response => {
      console.log('page--', response);
    });
  }



}
